import React from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Container from "@material-ui/core/Container";
import AuthedView from "../views/AuthedView";

interface AppRoutingProps {
  children: React.ReactChild | React.ReactChildren;
}

function AppRouting(props: AppRoutingProps) {
  const {children} = props;

  return (
    <Router>
      {children}
      <Container>
        <Switch>
          <Route path="/authed">
            <AuthedView/>
          </Route>
        </Switch>
      </Container>
    </Router>
  );
}

export default AppRouting;
